(() => {
  const HANDLES = new Set([
    '/products/utrecht-ketting-langwerpige-domtoren-hanger',
    '/products/ovale-utrecht-domtoren-ketting'
  ]);
  const storefrontPath = window.location.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '').replace(/\/$/, '');
  if (!HANDLES.has(storefrontPath)) return;

  const DC_UI_LANG = (document.documentElement.lang || 'nl').slice(0,2).toLowerCase();
  const DC_UI = {
    en: {
      backPrompt: 'What would you like engraved on the back?',
      text: 'Text',
      textMeta: 'Maximum 3 lines of text',
      coordsText: 'Coordinates + text',
      coordsMeta: 'Automatic coordinates with up to 2 additional text lines',
      coordsPrompt: 'Where would you like the coordinates?',
      firstLine: 'On the first line',
      coordsTop: 'Coordinates at the top, text below',
      lastLine: 'On the last line',
      textTop: 'Text at the top, coordinates below',
      coordinates: 'Coordinates',
      textLine1: 'Text line 1',
      textLine2: 'Text line 2',
      orderHelp: 'You can see the selected order directly in the preview below.',
      locationStatus: 'Enter an address or location. The coordinates will be found automatically.',
      locationVia: 'Location search via',
      mapData: 'map data © OpenStreetMap contributors.',
      introCoords: 'Enter an address or location. The webshop automatically converts it to coordinates. Optionally add up to 2 text lines and choose whether the coordinates appear at the top or bottom.',
      introText: 'Enter up to 3 lines of text, with a maximum of 12 characters per line including spaces.',
      line1Optional: 'Text line 1 <small>optional</small>',
      line2Optional: 'Text line 2 <small>optional</small>',
      line3Optional: 'Text line 3 <small>optional</small>',
      line1Required: 'Text line 1 <span>*</span>',
      locationLabel: 'Address or location for coordinates <span>*</span>',
      inactive: 'Automatic conversion to coordinates is not yet available.',
      inactiveShort: 'Automatic conversion is not yet available.',
      wait: 'Wait until the location has been checked.',
      searching: 'Searching for location...',
      notFound: 'Location not found. Enter, for example, street, house number and city.',
      found: 'Location found.',
      foundPrefix: 'Found:',
      timeout: 'Location search took too long. Please try again.',
      failed: 'The location could not be checked. Please try again.',
      checking: 'Checking location...',
      locationShort: 'Enter an address or location.'
    },
    de: {
      backPrompt: 'Was möchtest du auf die Rückseite gravieren lassen?',
      text: 'Text',
      textMeta: 'Maximal 3 Textzeilen',
      coordsText: 'Koordinaten + Text',
      coordsMeta: 'Automatische Koordinaten mit bis zu 2 zusätzlichen Textzeilen',
      coordsPrompt: 'Wo sollen die Koordinaten stehen?',
      firstLine: 'In der ersten Zeile',
      coordsTop: 'Koordinaten oben, Text darunter',
      lastLine: 'In der letzten Zeile',
      textTop: 'Text oben, Koordinaten darunter',
      coordinates: 'Koordinaten',
      textLine1: 'Textzeile 1',
      textLine2: 'Textzeile 2',
      orderHelp: 'Die gewählte Reihenfolge siehst du direkt in der Vorschau unten.',
      locationStatus: 'Gib eine Adresse oder einen Ort ein. Die Koordinaten werden automatisch gesucht.',
      locationVia: 'Standortsuche über',
      mapData: 'Kartendaten © OpenStreetMap-Mitwirkende.',
      introCoords: 'Gib eine Adresse oder einen Ort ein. Der Shop wandelt diese Angabe automatisch in Koordinaten um. Füge optional bis zu 2 Textzeilen hinzu und wähle, ob die Koordinaten oben oder unten stehen sollen.',
      introText: 'Gib bis zu 3 Textzeilen mit maximal 12 Zeichen pro Zeile einschließlich Leerzeichen ein.',
      line1Optional: 'Textzeile 1 <small>optional</small>',
      line2Optional: 'Textzeile 2 <small>optional</small>',
      line3Optional: 'Textzeile 3 <small>optional</small>',
      line1Required: 'Textzeile 1 <span>*</span>',
      locationLabel: 'Adresse oder Ort für Koordinaten <span>*</span>',
      inactive: 'Die automatische Umwandlung in Koordinaten ist noch nicht verfügbar.',
      inactiveShort: 'Die automatische Umwandlung ist noch nicht verfügbar.',
      wait: 'Warte, bis der Standort geprüft wurde.',
      searching: 'Standort wird gesucht...',
      notFound: 'Standort nicht gefunden. Gib zum Beispiel Straße, Hausnummer und Ort ein.',
      found: 'Standort gefunden.',
      foundPrefix: 'Gefunden:',
      timeout: 'Die Standortsuche hat zu lange gedauert. Bitte versuche es erneut.',
      failed: 'Der Standort konnte nicht geprüft werden. Bitte versuche es erneut.',
      checking: 'Standort wird geprüft...',
      locationShort: 'Gib eine Adresse oder einen Ort ein.'
    }
  };
  const dcUi = DC_UI[DC_UI_LANG] || null;
  const dcT = (key, fallback) => dcUi?.[key] || fallback;

  const STYLE_ID = 'dc-necklace-optimized-style';
  let bootObserver = null;
  let resizeQueued = false;

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .dc-necklace-mode,.dc-coordinate-position{grid-column:1/-1;margin:.1rem 0 .2rem;padding:0;border:0;min-width:0}
      .dc-necklace-mode__legend,.dc-coordinate-position__legend{display:block;width:100%;margin:0 0 .65rem;padding:0;font-weight:700;color:#2f3d32}
      .dc-necklace-mode__options,.dc-coordinate-position__options{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:.65rem}
      .dc-necklace-mode__option,.dc-coordinate-position__option{position:relative;display:block;min-width:0}
      .dc-necklace-mode__option input,.dc-coordinate-position__option input{position:absolute;width:1px;height:1px;opacity:0;pointer-events:none}
      .dc-necklace-mode__card,.dc-coordinate-position__card{display:block;height:100%;padding:.85rem .9rem;border:1px solid rgba(53,88,65,.20);border-radius:12px;background:#fff;cursor:pointer;transition:border-color .16s ease,box-shadow .16s ease,background .16s ease}
      .dc-necklace-mode__option input:checked + .dc-necklace-mode__card,.dc-coordinate-position__option input:checked + .dc-coordinate-position__card{border-color:#355841;background:#f4f8f3;box-shadow:0 0 0 2px rgba(53,88,65,.10)}
      .dc-necklace-mode__title,.dc-coordinate-position__title{display:block;font-weight:700;color:#2f3d32}
      .dc-necklace-mode__meta,.dc-coordinate-position__meta{display:block;margin-top:.2rem;font-size:.76rem;line-height:1.35;color:#6d746d}
      .dc-coordinate-position__order{display:grid;gap:.2rem;margin-top:.55rem;padding:.52rem .58rem;border-radius:9px;background:rgba(53,88,65,.045)}
      .dc-coordinate-position__order span{display:flex;align-items:center;gap:.4rem;font-size:.69rem;line-height:1.25;color:#5e675f}
      .dc-coordinate-position__order b{display:inline-grid;place-items:center;width:1.2rem;height:1.2rem;flex:0 0 1.2rem;border-radius:50%;background:#fff;border:1px solid rgba(53,88,65,.16);font-size:.61rem;color:#355841}
      .dc-coordinate-position__help{margin:.5rem 0 0;font-size:.72rem;line-height:1.4;color:#747b74}
      .dc-necklace-geocode{margin-top:.7rem}
      .dc-necklace-geocode__status{margin:0;font-size:.74rem;line-height:1.45;color:#6d746d}
      .dc-necklace-geocode__result{margin-top:.55rem;padding:.72rem .8rem;border:1px solid rgba(53,88,65,.16);border-radius:10px;background:#f7faf6}
      .dc-necklace-geocode__result strong{display:block;color:#2f3d32;font-size:.79rem}
      .dc-necklace-geocode__result span{display:block;margin-top:.18rem;color:#355841;font-size:.8rem;font-weight:700}
      .dc-necklace-geocode__attribution{margin:.5rem 0 0;font-size:.63rem;line-height:1.4;color:#7d837d}
      .dc-necklace-geocode__attribution a{color:inherit;text-underline-offset:2px}
      .dc-necklace-preview{font-size:clamp(2rem,7vw,3rem)!important;line-height:1.06!important;min-height:105px!important;display:flex!important;flex-direction:column!important;justify-content:center!important;gap:.05em!important;overflow:visible!important}
      .dc-necklace-preview [data-dc-preview-line]{display:block!important;box-sizing:border-box!important;width:100%!important;max-width:100%!important;white-space:nowrap!important;text-wrap:nowrap!important;overflow-wrap:normal!important;word-break:keep-all!important;hyphens:none!important;text-align:center!important}
      @media(max-width:430px){.dc-necklace-mode__options,.dc-coordinate-position__options{grid-template-columns:1fr}.dc-necklace-preview{font-size:clamp(1.9rem,8.4vw,2.65rem)!important}}
    `;
    document.head.appendChild(style);
  }

  function fieldFor(input) {
    return input?.closest('.dc-personalization__field') || null;
  }

  function getApiKey() {
    return document.querySelector('[data-dc-geoapify-key]')?.dataset.dcGeoapifyKey?.trim() || '';
  }

  function ensureHiddenProperty(box, name, marker) {
    let input = box.querySelector(`input[data-${marker}]`);
    if (input instanceof HTMLInputElement) return input;
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = `properties[${name}]`;
    input.setAttribute(`data-${marker}`, '');
    input.disabled = true;
    box.append(input);
    return input;
  }

  function createMode(fields) {
    let mode = fields.querySelector('[data-dc-necklace-mode]');
    if (mode instanceof HTMLElement) return mode;
    mode = document.createElement('fieldset');
    mode.className = 'dc-necklace-mode';
    mode.dataset.dcNecklaceMode = '';
    mode.innerHTML = `
      <legend class="dc-necklace-mode__legend">${dcT('backPrompt', 'Wat wil je op de achterkant laten graveren?')}</legend>
      <div class="dc-necklace-mode__options">
        <label class="dc-necklace-mode__option">
          <input type="radio" name="properties[Gravure achterkant]" value="Tekst" aria-label="${dcT('text', 'Tekst')}" checked>
          <span class="dc-necklace-mode__card"><span class="dc-necklace-mode__title">${dcT('text', 'Tekst')}</span><span class="dc-necklace-mode__meta">${dcT('textMeta', 'Maximaal 3 regels tekst')}</span></span>
        </label>
        <label class="dc-necklace-mode__option">
          <input type="radio" name="properties[Gravure achterkant]" value="Coördinaten + tekst" aria-label="${dcT('coordsText', 'Coördinaten + tekst')}">
          <span class="dc-necklace-mode__card"><span class="dc-necklace-mode__title">${dcT('coordsText', 'Coördinaten + tekst')}</span><span class="dc-necklace-mode__meta">${dcT('coordsMeta', 'Automatische coördinaten met maximaal 2 extra tekstregels')}</span></span>
        </label>
      </div>`;
    fields.insertBefore(mode, fields.firstElementChild);
    return mode;
  }

  function createPositionField() {
    const field = document.createElement('fieldset');
    field.className = 'dc-coordinate-position';
    field.dataset.dcCoordinatePosition = '';
    field.hidden = true;
    field.innerHTML = `
      <legend class="dc-coordinate-position__legend">${dcT('coordsPrompt', 'Waar wil je de coördinaten?')} <span>*</span></legend>
      <div class="dc-coordinate-position__options">
        <label class="dc-coordinate-position__option">
          <input type="radio" name="properties[Positie coördinaten]" value="Eerste regel, boven de tekst" aria-label="${dcT('firstLine', 'Op de eerste regel')}">
          <span class="dc-coordinate-position__card">
            <span class="dc-coordinate-position__title">${dcT('firstLine', 'Op de eerste regel')}</span>
            <span class="dc-coordinate-position__meta">${dcT('coordsTop', 'Coördinaten bovenaan, tekst eronder')}</span>
            <span class="dc-coordinate-position__order" aria-hidden="true"><span><b>1</b> ${dcT('coordinates', 'Coördinaten')}</span><span><b>2</b> ${dcT('textLine1', 'Tekstregel 1')}</span><span><b>3</b> ${dcT('textLine2', 'Tekstregel 2')}</span></span>
          </span>
        </label>
        <label class="dc-coordinate-position__option">
          <input type="radio" name="properties[Positie coördinaten]" value="Laatste regel, onder de tekst" aria-label="${dcT('lastLine', 'Op de laatste regel')}" checked>
          <span class="dc-coordinate-position__card">
            <span class="dc-coordinate-position__title">${dcT('lastLine', 'Op de laatste regel')}</span>
            <span class="dc-coordinate-position__meta">${dcT('textTop', 'Tekst bovenaan, coördinaten onderaan')}</span>
            <span class="dc-coordinate-position__order" aria-hidden="true"><span><b>1</b> ${dcT('textLine1', 'Tekstregel 1')}</span><span><b>2</b> ${dcT('textLine2', 'Tekstregel 2')}</span><span><b>3</b> ${dcT('coordinates', 'Coördinaten')}</span></span>
          </span>
        </label>
      </div>
      <p class="dc-coordinate-position__help">${dcT('orderHelp', 'Je ziet de gekozen volgorde direct terug in het voorbeeld hieronder.')}</p>`;
    return field;
  }

  function ensureGeocodeUi(locationField) {
    let wrap = locationField.querySelector('[data-dc-geocode-ui]');
    if (wrap instanceof HTMLElement) return wrap;
    wrap = document.createElement('div');
    wrap.className = 'dc-necklace-geocode';
    wrap.dataset.dcGeocodeUi = '';
    wrap.innerHTML = `
      <p class="dc-necklace-geocode__status" data-dc-geocode-status>${dcT('locationStatus', 'Vul een adres of locatie in. De coördinaten worden automatisch opgezocht.')}</p>
      <div class="dc-necklace-geocode__result" data-dc-geocode-result hidden><strong data-dc-geocode-address></strong><span data-dc-geocode-coordinates></span></div>
      <p class="dc-necklace-geocode__attribution">${dcT('locationVia', 'Locatiezoeker via')} <a href="https://www.geoapify.com/" target="_blank" rel="noopener">Geoapify</a>, ${dcT('mapData', 'kaartdata © OpenStreetMap-bijdragers.')}</p>`;
    locationField.append(wrap);
    return wrap;
  }

  function formatCoordinates(lat, lon) {
    return `${Math.abs(lat).toFixed(4)}° ${lat >= 0 ? 'N' : 'S'}, ${Math.abs(lon).toFixed(4)}° ${lon >= 0 ? 'E' : 'W'}`;
  }

  function setupBox(box) {
    if (!(box instanceof HTMLElement) || box.dataset.dcNecklaceOptimized === 'true') return box?.dataset?.dcNecklaceOptimized === 'true';

    const fields = box.querySelector('.dc-personalization__fields');
    const line1 = box.querySelector('input[name="properties[Regel 1]"]');
    const line2 = box.querySelector('input[name="properties[Regel 2]"]');
    const line3 = box.querySelector('input[name="properties[Regel 3]"]');
    const location = box.querySelector('input[name="properties[Adres of locatie voor coördinaten]"]');
    const preview = box.querySelector('[data-dc-preview]');
    if (!(fields instanceof HTMLElement) || !(line1 instanceof HTMLInputElement) || !(line2 instanceof HTMLInputElement) || !(line3 instanceof HTMLInputElement) || !(location instanceof HTMLInputElement) || !(preview instanceof HTMLElement)) return false;

    const line1Field = fieldFor(line1), line2Field = fieldFor(line2), line3Field = fieldFor(line3), locationField = fieldFor(location);
    if (!line1Field || !line2Field || !line3Field || !locationField) return false;

    ensureStyles();
    preview.classList.add('dc-necklace-preview');

    const mode = createMode(fields);
    const textRadio = mode.querySelector('input[value="Tekst"]');
    const coordsRadio = mode.querySelector('input[value="Coördinaten + tekst"]');
    if (!(textRadio instanceof HTMLInputElement) || !(coordsRadio instanceof HTMLInputElement)) return false;

    let positionField = fields.querySelector('[data-dc-coordinate-position]');
    if (!(positionField instanceof HTMLElement)) positionField = createPositionField();
    const topRadio = positionField.querySelector('input[value="Eerste regel, boven de tekst"]');
    const bottomRadio = positionField.querySelector('input[value="Laatste regel, onder de tekst"]');
    if (!(topRadio instanceof HTMLInputElement) || !(bottomRadio instanceof HTMLInputElement)) return false;

    if (mode.nextElementSibling !== locationField) fields.insertBefore(locationField, mode.nextElementSibling);
    if (locationField.nextElementSibling !== positionField) locationField.insertAdjacentElement('afterend', positionField);

    const line1Label = line1Field.querySelector('.dc-personalization__label');
    const line2Label = line2Field.querySelector('.dc-personalization__label');
    const line3Label = line3Field.querySelector('.dc-personalization__label');
    const locationLabel = locationField.querySelector('.dc-personalization__label');
    const intro = box.querySelector('.dc-personalization__intro');
    const previewLine1 = preview.querySelector('[data-dc-preview-line="1"]');
    const previewLine2 = preview.querySelector('[data-dc-preview-line="2"]');
    const previewLine3 = preview.querySelector('[data-dc-preview-line="3"]');
    if (!previewLine1 || !previewLine2 || !previewLine3) return false;

    const coordinatesProperty = ensureHiddenProperty(box, 'Coördinaten', 'dc-coordinates-property');
    const foundLocationProperty = ensureHiddenProperty(box, 'Gevonden locatie', 'dc-found-location-property');
    const geocodeUi = ensureGeocodeUi(locationField);
    const status = geocodeUi.querySelector('[data-dc-geocode-status]');
    const result = geocodeUi.querySelector('[data-dc-geocode-result]');
    const resultAddress = geocodeUi.querySelector('[data-dc-geocode-address]');
    const resultCoordinates = geocodeUi.querySelector('[data-dc-geocode-coordinates]');

    const state = { timer: 0, controller: null, timeout: 0, resolvedQuery: '', coordinates: '', formatted: '', renderQueued: false };

    const setStatus = (message, showResult = false) => {
      if (status) status.textContent = message;
      if (result instanceof HTMLElement) result.hidden = !showResult;
    };

    const clearResolved = () => {
      state.resolvedQuery = '';
      state.coordinates = '';
      state.formatted = '';
      coordinatesProperty.value = '';
      foundLocationProperty.value = '';
      coordinatesProperty.disabled = true;
      foundLocationProperty.disabled = true;
      if (resultAddress) resultAddress.textContent = '';
      if (resultCoordinates) resultCoordinates.textContent = '';
      if (result instanceof HTMLElement) result.hidden = true;
    };

    const abortRequest = () => {
      if (state.controller) state.controller.abort();
      state.controller = null;
      window.clearTimeout(state.timeout);
      state.timeout = 0;
    };

    const fitPreview = () => {
      const lines = [previewLine1, previewLine2, previewLine3];
      const available = Math.max(80, preview.clientWidth - 10);
      for (const line of lines) {
        line.style.fontSize = '';
        line.style.whiteSpace = 'nowrap';
        if (!line.textContent?.trim()) continue;
        const text = line.textContent.trim();
        const isCoordinates = /°\s*[NS].*°\s*[EW]$/.test(text);
        const width = line.scrollWidth;
        if (width <= available) continue;
        const base = parseFloat(getComputedStyle(line).fontSize) || 36;
        const ratio = available / Math.max(width, 1);
        const min = isCoordinates ? 16 : 20;
        let size = Math.max(min, Math.floor(base * ratio * 0.96));
        line.style.fontSize = `${size}px`;
        if (line.scrollWidth > available) {
          size = Math.max(14, Math.floor(size * available / Math.max(line.scrollWidth, 1) * 0.97));
          line.style.fontSize = `${size}px`;
        }
      }
    };

    const render = () => {
      state.renderQueued = false;
      const coordsMode = coordsRadio.checked;
      if (coordsMode) {
        const coords = state.coordinates || 'Coördinaten';
        if (topRadio.checked) {
          previewLine1.textContent = coords;
          previewLine2.textContent = line1.value.trim();
          previewLine3.textContent = line2.value.trim();
        } else {
          previewLine1.textContent = line1.value.trim();
          previewLine2.textContent = line2.value.trim();
          previewLine3.textContent = coords;
        }
      } else {
        previewLine1.textContent = line1.value.trim() || 'Sophie & Thomas';
        previewLine2.textContent = line2.value.trim() || '14-06-2026';
        previewLine3.textContent = line3.value.trim();
      }
      requestAnimationFrame(fitPreview);
    };

    const scheduleRender = () => {
      if (state.renderQueued) return;
      state.renderQueued = true;
      requestAnimationFrame(render);
    };

    const geocode = async () => {
      window.clearTimeout(state.timer);
      state.timer = 0;
      const query = location.value.trim();
      if (!coordsRadio.checked || box.hidden || query.length < 3) return;
      if (state.resolvedQuery === query && state.coordinates) return;

      const apiKey = getApiKey();
      if (!apiKey) {
        clearResolved();
        location.setCustomValidity(dcT('inactive', 'Automatisch omzetten naar coördinaten is nog niet geactiveerd.'));
        setStatus(dcT('inactiveShort', 'Automatisch omzetten is nog niet geactiveerd.'));
        scheduleRender();
        return;
      }

      abortRequest();
      state.controller = new AbortController();
      clearResolved();
      location.setCustomValidity(dcT('wait', 'Wacht tot de locatie is gecontroleerd.'));
      setStatus(dcT('searching', 'Locatie zoeken...'));
      scheduleRender();
      state.timeout = window.setTimeout(() => state.controller?.abort(), 8000);

      try {
        const url = new URL('https://api-eu.geoapify.com/v1/geocode/search');
        url.searchParams.set('text', query);
        url.searchParams.set('format', 'json');
        url.searchParams.set('limit', '1');
        url.searchParams.set('apiKey', apiKey);
        const response = await fetch(url, { signal: state.controller.signal, mode: 'cors' });
        if (!response.ok) throw new Error(`Geocoding ${response.status}`);
        const data = await response.json();
        const first = Array.isArray(data.results) ? data.results[0] : null;
        const lat = Number(first?.lat), lon = Number(first?.lon);
        if (!first || !Number.isFinite(lat) || !Number.isFinite(lon)) {
          location.setCustomValidity(dcT('notFound', 'Locatie niet gevonden. Vul bijvoorbeeld straat, huisnummer en plaats in.'));
          setStatus(dcT('notFound', 'Locatie niet gevonden. Vul bijvoorbeeld straat, huisnummer en plaats in.'));
          scheduleRender();
          return;
        }
        state.resolvedQuery = query;
        state.coordinates = formatCoordinates(lat, lon);
        state.formatted = String(first.formatted || query);
        coordinatesProperty.value = state.coordinates;
        foundLocationProperty.value = state.formatted;
        coordinatesProperty.disabled = false;
        foundLocationProperty.disabled = false;
        location.setCustomValidity('');
        if (resultAddress) resultAddress.textContent = `${dcT('foundPrefix', 'Gevonden:')} ${state.formatted}`;
        if (resultCoordinates) resultCoordinates.textContent = state.coordinates;
        setStatus(dcT('found', 'Locatie gevonden.'), true);
        scheduleRender();
      } catch (error) {
        if (error?.name === 'AbortError') {
          if (location.value.trim() === query) {
            location.setCustomValidity(dcT('timeout', 'Locatie zoeken duurde te lang. Probeer het opnieuw.'));
            setStatus(dcT('timeout', 'Locatie zoeken duurde te lang. Probeer het opnieuw.'));
          }
        } else {
          clearResolved();
          location.setCustomValidity(dcT('failed', 'Locatie kon niet worden gecontroleerd. Probeer het opnieuw.'));
          setStatus(dcT('failed', 'Locatie kon niet worden gecontroleerd. Probeer het opnieuw.'));
        }
        scheduleRender();
      } finally {
        window.clearTimeout(state.timeout);
        state.timeout = 0;
        state.controller = null;
      }
    };

    const scheduleGeocode = () => {
      window.clearTimeout(state.timer);
      abortRequest();
      clearResolved();
      if (!coordsRadio.checked) return;
      const query = location.value.trim();
      location.setCustomValidity(query ? dcT('wait', 'Wacht tot de locatie is gecontroleerd.') : dcT('locationShort', 'Vul een adres of locatie in.'));
      setStatus(query ? dcT('checking', 'Locatie wordt gecontroleerd...') : dcT('locationStatus', 'Vul een adres of locatie in. De coördinaten worden automatisch opgezocht.'));
      scheduleRender();
      if (query.length >= 3) state.timer = window.setTimeout(geocode, 450);
    };

    const applyMode = () => {
      const active = !box.hidden;
      const coordsMode = active && coordsRadio.checked;

      textRadio.disabled = !active;
      coordsRadio.disabled = !active;
      topRadio.disabled = !coordsMode;
      bottomRadio.disabled = !coordsMode;
      positionField.hidden = !coordsMode;
      locationField.hidden = !coordsMode;
      line3Field.hidden = coordsMode;

      line1.disabled = !active;
      line2.disabled = !active;
      line3.disabled = !active || coordsMode;
      location.disabled = !coordsMode;
      line1.required = active && !coordsMode;
      line2.required = false;
      line3.required = false;
      location.required = coordsMode;
      line1.setCustomValidity('');

      if (coordsMode) {
        if (line1Label) line1Label.innerHTML = dcT('line1Optional', 'Tekstregel 1 <small>optioneel</small>');
        if (line2Label) line2Label.innerHTML = dcT('line2Optional', 'Tekstregel 2 <small>optioneel</small>');
        if (locationLabel) locationLabel.innerHTML = dcT('locationLabel', 'Adres of locatie voor coördinaten <span>*</span>');
        if (intro) intro.textContent = dcT('introCoords', 'Vul een adres of locatie in. De webshop zet dit automatisch om naar coördinaten. Voeg eventueel maximaal 2 tekstregels toe en kies of de coördinaten bovenaan of onderaan komen.');
        if (!topRadio.checked && !bottomRadio.checked) bottomRadio.checked = true;
        if (line3.value) line3.value = '';
        if (location.value.trim() && !state.coordinates) scheduleGeocode();
      } else if (active) {
        if (line1Label) line1Label.innerHTML = dcT('line1Required', 'Tekstregel 1 <span>*</span>');
        if (line2Label) line2Label.innerHTML = dcT('line2Optional', 'Tekstregel 2 <small>optioneel</small>');
        if (line3Label) line3Label.innerHTML = dcT('line3Optional', 'Tekstregel 3 <small>optioneel</small>');
        if (intro) intro.textContent = dcT('introText', 'Vul maximaal 3 regels tekst in, met maximaal 12 tekens per regel inclusief spaties.');
        window.clearTimeout(state.timer);
        abortRequest();
        location.value = '';
        location.setCustomValidity('');
        clearResolved();
      } else {
        window.clearTimeout(state.timer);
        abortRequest();
        location.setCustomValidity('');
        coordinatesProperty.disabled = true;
        foundLocationProperty.disabled = true;
      }
      scheduleRender();
    };

    const lineInput = () => {
      if (coordsRadio.checked) line1.setCustomValidity('');
      scheduleRender();
    };

    textRadio.addEventListener('change', applyMode);
    coordsRadio.addEventListener('change', applyMode);
    topRadio.addEventListener('change', scheduleRender);
    bottomRadio.addEventListener('change', scheduleRender);
    line1.addEventListener('input', lineInput);
    line2.addEventListener('input', lineInput);
    line3.addEventListener('input', lineInput);
    location.addEventListener('input', scheduleGeocode);
    location.addEventListener('blur', () => {
      if (!coordsRadio.checked || state.coordinates || location.value.trim().length < 3) return;
      window.clearTimeout(state.timer);
      geocode();
    });

    box.querySelectorAll('[data-dc-font]').forEach((font) => font.addEventListener('change', scheduleRender));

    const hiddenObserver = new MutationObserver(applyMode);
    hiddenObserver.observe(box, { attributes: true, attributeFilter: ['hidden'] });

    box.dataset.dcNecklaceOptimized = 'true';
    applyMode();

    if (document.fonts?.ready) document.fonts.ready.then(scheduleRender).catch(() => {});
    return true;
  }

  function setupAll() {
    const boxes = [...document.querySelectorAll('domstad-personalization')];
    if (!boxes.length) return false;
    let ready = true;
    for (const box of boxes) if (!setupBox(box)) ready = false;
    return ready;
  }

  function start() {
    if (!setupAll()) {
      bootObserver = new MutationObserver(() => {
        if (setupAll() && bootObserver) bootObserver.disconnect();
      });
      bootObserver.observe(document.body, { childList: true, subtree: true });
    }

    window.addEventListener('resize', () => {
      if (resizeQueued) return;
      resizeQueued = true;
      requestAnimationFrame(() => {
        resizeQueued = false;
        document.querySelectorAll('domstad-personalization[data-dc-necklace-optimized="true"] [data-dc-preview]').forEach((preview) => {
          preview.dispatchEvent(new Event('dc-resize-preview'));
        });
      });
    }, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
